var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 10.5865L16.9505 5.63672L18.3647 7.05093L13.4149 12.0007L18.3647 16.9504L16.9505 18.3646L12.0007 13.4149L7.05094 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05094 5.63672L12.0007 10.5865Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseMenu);
export default __webpack_public_path__ + "static/media/icon_close_menu.969ebc796c4fc0cd7bdd279d79d742f5.svg";
export { ForwardRef as ReactComponent };